export const TRADESHOW_BUCKS = { '=0': 'Tradeshow Bucks', '=1': 'Tradeshow Buck', other: 'Tradeshow Bucks' };
export const ITEM_REMAINS_ERROR = { '=1': 'One item was not ordered and remains in your cart', other: '# items where not ordered and remain in your cart' };
export const ITEMS = { '=1': 'Item', other: 'Items' };
export const AD_POINTS = { '=0': 'AD Rewards', '=1': 'AD Reward', other: 'AD Rewards' };
